const putRooms = (rooms) => ({
  type: 'ROOMS_PUT',
  payload: {
    rooms
  }
})

const putRoomAttributes = (roomAttributes) => ({
  type: 'ROOM_ATTRIBUTES_PUT',
  payload: {
    roomAttributes
  }
})

export const roomActions = {
  putRooms,
  putRoomAttributes
}
